<template>
  <v-list dense>
    <v-list-item v-for="(task, taskIndex) in tasks" :key="taskIndex">
      <div class="d-flex align-center">
        <v-icon
          :color="TaskStatusHelper.getIconColor(task.status)"
          class="mr-3"
        >
          {{ TaskStatusHelper.getIcon(task.status) }}
        </v-icon>
        <v-list-item-title>
          {{ task.title }} - {{ task.description }} -
          {{ TaskHelpers.getTaskTimeTaken(task) }}
        </v-list-item-title>
      </div>
      <div v-if="task.response">
        <p
          v-for="(response, responseIndex) in task.response"
          :key="responseIndex"
        >
          {{ response }}
        </p>
      </div>
    </v-list-item>
  </v-list>
</template>

<script lang="ts" setup>
  import TaskStatusHelper from '@/helpers/taskStatusHelpers';
  import { TaskHelpers } from '@/helpers/taskHelpers';
  import ITaskItem from '@/interfaces/ITaskItem';

  defineProps<{
    tasks: ITaskItem[]; // Required tasks prop
  }>();
</script>
